import * as React from 'react';

import './style.scss';

interface Props {
  className?: string
  children: React.ReactNode
}

type TableSubComponents = {
  Row: typeof Row
  Cell: typeof Cell
  Head: typeof Head
  Body: typeof Body
  Skeleton: typeof Skeleton
};

const Table: React.FC<Props> & TableSubComponents = ({
  className,
  children,
}) => (
  <div className={`Table ${className || ''}`}>
    {children}
  </div>
);

const Head: React.FC<Props> = ({
  children,
}) => (
  <div className="Table__Head">
    {children}
  </div>
);
Table.Head = Head;

const Body: React.FC<Props> = ({
  children,
}) => (
  <div className="Table__Body">
    {children}
  </div>
);
Table.Body = Body;

const Cell: React.FC<Props> = ({
  className,
  children,
}) => (
  <div className={`Table__Cell ${className || ''}`}>
    {children}
  </div>
);
Table.Cell = Cell;

const Row: React.FC<Props> = ({
  className,
  children,
}) => (
  <div className={`Table__Row ${className || ''}`}>
    {children}
  </div>
);
Table.Row = Row;

const Skeleton: React.FC<Props> = ({
  children,
}) => (
  <div className="Table__Cell__Skeleton" style={{ width: `${Math.random() * (75 - 25) + 25}%` }}>
    {children}
  </div>
);
Table.Skeleton = Skeleton;

export default Table;
